import {
  titleUI,
  radioUI,
  radioSchema,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import ConditionalRevealRadioField from '../components/ConditionalRevealRadioField';
import {
  applicationInfoFields,
  CONVEYANCE_TYPES,
  FORM_21_4502,
} from '../definitions/constants';

const { VEHICLE_DETAILS: VD } = FORM_21_4502;

const conveyanceTypeUI = radioUI({
  title: VD.QUESTION_TYPE,
  labels: CONVEYANCE_TYPES,
  required: () => true,
  errorMessages: {
    required: VD.ERROR_TYPE,
  },
});

/** @type {PageSchema} */
export default {
  uiSchema: {
    'ui:options': { preserveHiddenData: true, forceDivWrapper: true },
    ...titleUI(VD.TITLE, VD.PAGE_DESCRIPTION),
    [applicationInfoFields.parentObject]: {
      [applicationInfoFields.conveyanceType]: {
        ...conveyanceTypeUI,
        'ui:options': {
          ...(conveyanceTypeUI['ui:options'] || {}),
          conditionalRevealValues: ['other'],
        },
        'ui:webComponentField': ConditionalRevealRadioField,
      },
      [applicationInfoFields.otherConveyanceType]: {
        ...textUI({
          title: VD.OTHER_SPECIFY,
          required: formData =>
            formData?.applicationInfo?.conveyanceType === 'other',
          errorMessages: {
            required: VD.ERROR_OTHER,
          },
          hideIf: formData =>
            formData?.applicationInfo?.conveyanceType !== 'other',
          hideEmptyValueInReview: true,
        }),
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      [applicationInfoFields.parentObject]: {
        type: 'object',
        properties: {
          [applicationInfoFields.conveyanceType]: radioSchema(
            Object.keys(CONVEYANCE_TYPES),
          ),
          [applicationInfoFields.otherConveyanceType]: {
            type: 'string',
            maxLength: 100,
          },
        },
        required: [applicationInfoFields.conveyanceType],
      },
    },
  },
};
